import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  validateFileSize(event) {
    const fileInput = event.target;
    const uploadZone = this.uploadZoneFor(fileInput);
    const files = this.filesForValidation(fileInput, uploadZone);
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    const warningSize = 5 * 1024 * 1024; // 5MB in bytes - show warning
    const warningDiv = document.getElementById("file-size-warning");
    const warningMessage = document.getElementById("file-size-message");
    const submitButton = document.getElementById("submit-button");

    if (files.length === 0) {
      warningDiv?.classList.add("hidden");
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add("btn-disabled");
        delete submitButton.dataset.sizeBlocked;
      }
      uploadZone?.updateSubmitState();
      return;
    }

    let hasLargeFiles = false;
    let hasVeryLargeFiles = false;
    let largestFile = null;
    let largestSize = 0;

    for (const file of files) {

      if (file.size > largestSize) {
        largestSize = file.size;
        largestFile = file;
      }

      if (file.size > maxSize) {
        hasVeryLargeFiles = true;
      } else if (file.size > warningSize) {
        hasLargeFiles = true;
      }
    }

    if (hasVeryLargeFiles) {
      // Files too large - block submission
      warningDiv.classList.remove("hidden", "alert-warning");
      warningDiv.classList.add("alert-error");
      warningMessage.textContent = `Fichier trop volumineux : ${
        largestFile.name
      } (${this.formatFileSize(largestSize)}). Maximum autorisé : 10 MB.`;
      submitButton.disabled = true;
      submitButton.classList.add("btn-disabled");
      submitButton.dataset.sizeBlocked = "true";
      uploadZone?.setSizeBlocked(true);
    } else if (hasLargeFiles) {
      // Large files - show warning but allow submission
      warningDiv.classList.remove("hidden", "alert-error");
      warningDiv.classList.add("alert-warning");
      warningMessage.textContent = `Fichier volumineux détecté : ${
        largestFile.name
      } (${this.formatFileSize(largestSize)}). Le traitement peut échouer.`;
      delete submitButton.dataset.sizeBlocked;
      uploadZone?.setSizeBlocked(false);
    } else {
      // Normal file sizes
      warningDiv.classList.add("hidden");
      delete submitButton.dataset.sizeBlocked;
      uploadZone?.setSizeBlocked(false);
    }
  }

  uploadZoneFor(fileInput) {
    const host = fileInput.closest("[data-controller*='document-upload-zone']");
    if (!host) return null;

    return this.application.getControllerForElementAndIdentifier(
      host,
      "document-upload-zone"
    );
  }

  filesForValidation(fileInput, uploadZone) {
    if (uploadZone?.files?.length > 0) {
      return uploadZone.files;
    }

    return Array.from(fileInput.files || []);
  }

  formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }
}
